<template>
  <main class="login-page">
    <section class="login-brand" aria-label="Presentación de Qhatu">
      <div class="brand-overlay"></div>
      <div class="brand-content">
        <div class="brand-heading">
          <img src="../../assets/qhatunavbar2.png" alt="Qhatu" class="brand-logo" />
          <span class="brand-badge">Portal de clientes</span>
        </div>
        <h1>Información clara para tomar mejores decisiones.</h1>
        <p>Accede de forma segura a tus indicadores, reportes y herramientas empresariales.</p>
      </div>
      <div class="brand-footer">Grupo Solimano</div>
    </section>

    <section class="login-panel">
      <div class="mobile-brand">
        <img src="../../assets/qhatunavbar2.png" alt="Qhatu" />
        <span>Portal de clientes</span>
      </div>

      <div class="login-card">
        <div class="login-heading">
          <span class="eyebrow">Bienvenido</span>
          <h2>Inicia sesión</h2>
          <p>Ingresa tus credenciales para continuar.</p>
        </div>

        <form @submit.prevent="handleLogin" novalidate>
          <div class="form-group">
            <label for="usuario">Usuario</label>
            <div class="input-control">
              <i class="bi bi-person" aria-hidden="true"></i>
              <input
                id="usuario"
                v-model.trim="user.usuCodigo"
                type="text"
                autocomplete="username"
                placeholder="Ingresa tu usuario"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label for="contrasena">Contraseña</label>
            <div class="input-control">
              <i class="bi bi-lock" aria-hidden="true"></i>
              <input
                id="contrasena"
                v-model="user.usuContrasena"
                :type="mostrarContrasena ? 'text' : 'password'"
                autocomplete="current-password"
                placeholder="Ingresa tu contraseña"
                required
              />
              <button
                type="button"
                class="password-toggle"
                :aria-label="mostrarContrasena ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                @click="mostrarContrasena = !mostrarContrasena"
              >
                <i :class="mostrarContrasena ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </button>
            </div>
          </div>

          <button class="login-button" type="submit" :disabled="cargando || !formularioValido">
            <span v-if="cargando" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span>{{ cargando ? 'Validando acceso...' : 'Ingresar a Qhatu' }}</span>
            <i v-if="!cargando" class="bi bi-arrow-right"></i>
          </button>
        </form>

        <p class="support-text">
          ¿Tienes problemas para ingresar? Comunícate con tu ejecutivo o mesa de ayuda.
        </p>
      </div>
    </section>
  </main>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "BYLogin",
  data() {
    return {
      cargando: false,
      mostrarContrasena: false,
      user: { usuCodigo: "", usuContrasena: "" },
    };
  },
  computed: {
    formularioValido() {
      return this.user.usuCodigo.length > 0 && this.user.usuContrasena.length > 0;
    },
  },
  methods: {
    ...mapActions("auth", ["login"]),
    async handleLogin() {
      if (!this.formularioValido || this.cargando) return;
      this.cargando = true;
      try {
        await this.login(this.user);
        const redirect = this.$route.query.redirect;
        await this.$router.replace(redirect && redirect !== "/" ? redirect : "/Home");
      } catch (mensajePersonalizado) {
        this.cargando = false;
        Swal.fire({
          title: "No pudimos iniciar sesión",
          text: mensajePersonalizado,
          icon: "error",
          confirmButtonText: "Entendido",
          confirmButtonColor: "#0b5db7",
        });
      }
    },
  },
};
</script>

<style scoped>
.login-page { min-height: 100vh; display: grid; grid-template-columns: minmax(420px, 1.1fr) minmax(420px, .9fr); background: #fff; }
.login-brand { position: relative; min-height: 100vh; overflow: hidden; background: linear-gradient(145deg, #063d75, #0b5db7 55%, #1688d4); color: #fff; padding: clamp(2rem, 5vw, 5rem); display: flex; flex-direction: column; justify-content: center; }
.login-brand::before { content: ""; position: absolute; inset: 0; background: url("../../assets/6.png") center/cover no-repeat; opacity: .28; }
.brand-overlay { position: absolute; width: 520px; height: 520px; border-radius: 50%; background: rgba(255,255,255,.08); right: -180px; top: -140px; }
.brand-content, .brand-footer { position: relative; z-index: 1; }
.brand-heading { display: flex; flex-direction: column; align-items: flex-start; gap: .75rem; margin-bottom: 1.6rem; }
.brand-logo { width: min(280px, 68%); max-height: 82px; object-fit: contain; object-position: left center; margin-bottom: 0; }
.brand-badge { display: inline-flex; border: 1px solid rgba(255,255,255,.35); background: rgba(255,255,255,.12); padding: .5rem .95rem; border-radius: 999px; font-size: .82rem; font-weight: 650; letter-spacing: .03em; }
.brand-content h1 { max-width: 650px; margin: 0 0 .9rem; font-size: clamp(2.1rem, 4vw, 4.2rem); line-height: 1.05; font-weight: 760; }
.brand-content p { max-width: 560px; font-size: clamp(1rem, 1.4vw, 1.2rem); line-height: 1.65; color: rgba(255,255,255,.85); }
.brand-footer { position: absolute; left: clamp(2rem, 5vw, 5rem); bottom: 2rem; font-size: .9rem; color: rgba(255,255,255,.72); }
.login-panel { display: flex; justify-content: center; align-items: center; padding: clamp(1.5rem, 5vw, 5rem); background: #fff; }
.login-card { width: min(100%, 440px); }
.mobile-brand { display: none; }
.login-heading .eyebrow { color: var(--qhatu-primary); font-weight: 750; text-transform: uppercase; font-size: .76rem; letter-spacing: .12em; }
.login-heading h2 { margin: .45rem 0 .5rem; font-size: clamp(1.85rem, 3vw, 2.45rem); font-weight: 760; color: var(--qhatu-text); }
.login-heading p { color: var(--qhatu-muted); margin-bottom: 2rem; }
.form-group { margin-bottom: 1.2rem; text-align: left; }
.form-group label { display: block; margin-bottom: .5rem; font-size: .9rem; font-weight: 650; color: #344055; }
.input-control { min-height: 52px; border: 1px solid var(--qhatu-border); border-radius: 12px; display: flex; align-items: center; padding: 0 .9rem; transition: border-color .2s, box-shadow .2s; }
.input-control:focus-within { border-color: var(--qhatu-primary); box-shadow: 0 0 0 4px rgba(11,93,183,.10); }
.input-control > i { color: #7b879a; font-size: 1.1rem; }
.input-control input { flex: 1; min-width: 0; border: 0; outline: 0; height: 50px; padding: 0 .75rem; color: var(--qhatu-text); background: transparent; }
.input-control input::placeholder { color: #9aa5b5; }
.password-toggle { width: 44px; height: 44px; border: 0; background: transparent; border-radius: 10px; color: #657187; display: grid; place-items: center; }
.login-button { margin-top: .5rem; width: 100%; min-height: 52px; border: 0; border-radius: 12px; padding: 0 1.1rem; background: var(--qhatu-primary); color: #fff; font-weight: 700; display: flex; align-items: center; justify-content: center; gap: .7rem; transition: transform .2s, background .2s, box-shadow .2s; }
.login-button:hover:not(:disabled) { background: var(--qhatu-primary-dark); transform: translateY(-1px); box-shadow: 0 10px 24px rgba(11,93,183,.22); }
.login-button:disabled { opacity: .62; cursor: not-allowed; }
.support-text { margin: 1.6rem auto 0; max-width: 360px; text-align: center; color: var(--qhatu-muted); font-size: .84rem; line-height: 1.5; }
@media (max-width: 900px) {
  .login-page { grid-template-columns: 1fr; background: linear-gradient(145deg, #eef5fc, #fff); }
  .login-brand { display: none; }
  .login-panel { min-height: 100vh; flex-direction: column; padding: 1.25rem; }
  .mobile-brand { display: flex; flex-direction: column; align-items: center; gap: .35rem; margin-bottom: 1.6rem; color: var(--qhatu-primary); font-size: .8rem; font-weight: 700; text-transform: uppercase; letter-spacing: .08em; }
  .mobile-brand img { width: 150px; max-height: 48px; object-fit: contain; filter: drop-shadow(0 4px 10px rgba(11,93,183,.12)); }
  .login-card { padding: 1.5rem; background: #fff; border: 1px solid var(--qhatu-border); border-radius: 20px; box-shadow: var(--qhatu-shadow); }
}
@media (max-width: 420px) { .login-panel { padding: .85rem; } .login-card { padding: 1.25rem; } }
</style>
